import cn from "classnames";
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import styles from "./LandingPage.module.scss";
const image1 = `${process.env.PUBLIC_URL}/interactive-exercise1.png`;
const image2 = `${process.env.PUBLIC_URL}/interactive-exercise2.png`;
const image3 = `${process.env.PUBLIC_URL}/interactive-exercise3.png`;
const image4 = `${process.env.PUBLIC_URL}/interactive-exercise4.png`;
const mobileMockup1 = `${process.env.PUBLIC_URL}/mobileMockup1.png`;
const mobileMockup2 = `${process.env.PUBLIC_URL}/mobileMockup2.png`;
const mobileMockup3 = `${process.env.PUBLIC_URL}/mobileMockup3.png`;
const mobileMockup4 = `${process.env.PUBLIC_URL}/mobileMockup4.png`;

export const LandingPage = () => {
	const [device, setDevice] = React.useState("mobile");
	return (
		<div className={styles.lingvoContainer}>
			<Helmet>
				<title>Welcome to SkillerDome - Learn, Play, Grow</title>
				<meta
					name="description"
					content="Discover SkillerDome - the ultimate platform for language learning, interactive games, and personal growth. Start learning today!"
				/>
				<link rel="canonical" href="https://skillerdome.com/" />
			</Helmet>
			<header className={styles.lingvoHeader}>
				<nav className={styles.lingvoNav}>
					<a href="/" className={styles.lingvoLogo}>
						<strong>SkillerDome</strong>
					</a>
					<div className={styles.lingvoLinks}>
						{/* Static, SEO-friendly anchor tags */}
						<a href="/courses">Language Courses</a>
						<a href="/games">Play Games</a>
						<a href="/blog">Blog</a>
						<a href="/about">About Me</a>
					</div>
					<div className={styles.lingvoButtons}>
						<a href="/login" className={styles.lingvoGetStartedButton}>
							Login
						</a>
					</div>
				</nav>
			</header>

			<main className={styles.lingvoMainContent}>
				<div className={styles.mainContentLeft}>
					<h3>
						Built by <span className={styles.highlight}>teacher</span>. Powered
						by <span className={styles.highlight}>technology</span>.
					</h3>
					<p className={styles.description}>
						The world-leading platform with 10,000+ successful lessons
					</p>
					<Link to="/register" className={styles.ctaButton}>
						Start for free
					</Link>
				</div>

				<div className={styles.mainContentRight}>
					<div className={styles.deviceSelector}>
						<button
							type="button"
							className={cn(styles.deviceSelectBtn, {
								[styles.activeDevice]: device === "mobile",
							})}
							onClick={() => setDevice("mobile")}
						>
							mobile
						</button>
						<button
							type="button"
							className={cn(styles.deviceSelectBtn, {
								[styles.activeDevice]: device === "desktop",
							})}
							onClick={() => setDevice("desktop")}
						>
							desktop
						</button>
					</div>
					{device === "desktop" && (
						<div className={styles.circlesSection}>
							<div className={styles.circle}>
								<img src={image1} alt="Teacher 1" />
							</div>
							<div className={styles.circle}>
								<img src={image2} alt="Teacher 2" />
							</div>
							<div className={styles.circle}>
								<img src={image3} alt="Teacher 3" />
							</div>
							<div className={styles.circle}>
								<img src={image4} alt="Teacher 3" />
							</div>
						</div>
					)}
					{device === "mobile" && (
						<div className={styles.circlesSection}>
							<div className={styles.circle}>
								<img src={mobileMockup1} alt="Teacher 1" />
							</div>
							<div className={styles.circle}>
								<img src={mobileMockup2} alt="Teacher 2" />
							</div>
							<div className={styles.circle}>
								<img src={mobileMockup3} alt="Teacher 3" />
							</div>
							<div className={styles.circle}>
								<img src={mobileMockup4} alt="Teacher 3" />
							</div>
						</div>
					)}
				</div>
			</main>
		</div>
	);
};
